<!-- ./src/pages/admin/Products.vue -->
<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Usuarios
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              small 
              color="blue"
              class="mr-2 ml-2" 
              @click="novo()">
              Novo Usuário
            </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="usuarios"
            :search="search"
            class="compact-form"
          >
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editSenha(item)"
              >
                lock
              </v-icon>
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogSenha" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Alterar Senha</span>
        </v-card-title>
        <v-card-text>
          <v-row >
            <v-col cols="3"  >
              <v-subheader class="justify-end">Nome</v-subheader>
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="model.name"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3"  >
              <v-subheader class="justify-end">Email</v-subheader>
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="model.username"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3"  >
              <v-subheader class="justify-end">Senha</v-subheader>
            </v-col>
            <v-col cols="9">
              <v-text-field
                label="Senha"
                type="password"
                v-model="model.senha"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="clearSenha()">Fechar</v-btn>
          <v-btn small color="blue darken-1" @click.native="saveSenha()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Cadastrar Usuário</span>
        </v-card-title>
        <v-card-text>
          <form @submit.prevent="save()" class="compact-form">
            <v-row >
              <v-col cols="3"  >
                <v-subheader class="justify-end">Nome</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  v-model="model.name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3"  >
                <v-subheader class="justify-end">Email</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  v-model="model.username"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="!editando">
              <v-col cols="3"  >
                <v-subheader class="justify-end">Senha</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  label="Senha"
                  type="password"
                  v-model="model.senha"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3"  >
                <v-subheader class="justify-end">Acesso</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-select
                  :items="options"
                  label="Acesso"
                  v-model="model.acesso"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-show="user?user.grand == 'Geral':false">
              <v-col cols="3">
                <v-subheader class="justify-end">Empresa</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-select
                  :items="empresas"
                  label="Empresa"
                  v-model="model.empresa"
                  item-value="_id"
                  item-text="nome"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-show="model.acesso == 'Cliente'">
              <v-col cols="3">
                <v-subheader class="justify-end">Cliente</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-select
                  :items="clientes"
                  label="Cliente"
                  v-model="model.cliente"
                  item-value="_id"
                  item-text="Nome"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-show="model.acesso == 'AdminClientes'">
              <v-col cols="3">
                <v-subheader class="justify-end">Cliente</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-select
                  :items="clientes"
                  label="Cliente"
                  v-model="model.userClientes"
                  item-value="_id"
                  item-text="Nome"
                  multiple
                ></v-select>
              </v-col>
            </v-row>
            <!-- <v-row v-show="model.acesso == 'Devedor'">
              <v-col cols="3">
                <v-subheader class="justify-end">Devedores</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-select
                  :items="devedores"
                  label="Devedores"
                  v-model="model.devedor"
                  item-value="_id"
                  item-text="Nome"
                ></v-select>
              </v-col>
            </v-row> -->
            <v-row v-show="model.acesso == 'Funcionario'">
              <v-col cols="3">
                <v-subheader class="justify-end">Meta 1</v-subheader>
              </v-col>
              <v-col cols="9">
                
                <v-currency-field  
                  label="Meta 1" 
                  prefix="R$ "
                  v-model="model.meta1" />
                <!-- <v-text-field
                  label="Meta 1"
                  ref="meta1"
                  v-model="model.meta1"
                  v-money="money"
                  prefix="R$ "
                  required
                ></v-text-field> -->
              </v-col>
            </v-row>
            <v-row v-show="model.acesso == 'Funcionario'">
              <v-col cols="3">
                <v-subheader class="justify-end">Meta 2</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-currency-field  
                  label="Meta 2" 
                  prefix="R$ "
                  v-model="model.meta2" />
                <!-- <v-text-field
                  label="Meta 2"
                  ref="meta2"
                  v-model="model.meta2"
                  v-money="money"
                  prefix="R$ "
                  required
                ></v-text-field> -->
              </v-col>
            </v-row>
            <v-row v-show="model.acesso == 'Funcionario'">
              <v-col cols="3">
                <v-subheader class="justify-end">Meta 3</v-subheader>
              </v-col>
              <v-col cols="9">
                <v-currency-field  
                  label="Meta 3" 
                  prefix="R$ "
                  v-model="model.meta3" />
                <!-- <v-text-field
                  label="Meta 3"
                  ref="meta3"
                  v-model="model.meta3"
                  v-money="money"
                  prefix="R$ "
                  required
                ></v-text-field> -->
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="clear()">Fechar</v-btn>
          <v-btn small color="blue darken-1" @click.native="save()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="dialogConfirmation = false">Não</v-btn>
          <v-btn small color="blue darken-1" @click.native="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
  import { mapMutations } from "vuex";  
  import store from "@/store";
  import usuario from "@/services/usuario";
  import cliente from "@/services/cliente";
  import empresaCtrl from "@/services/empresa";
  import devedores from "@/services/devedores";
  import {VMoney} from 'v-money';

  export default {
    name: 'home',
    data () {
      return {
        search: '',
        snackbar: false,
        message: '',
        loading: true,
        dialog: false,
        dialogSenha: false,
        dialogError: false,
        dialogConfirmation: false,
        editando: false,
        excluindo: {},
        idZabbix: '',
        user: {},
        usuarios: [],
        clientes: [],
        devedores: [],
        empresas: [],
        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2
        },
        options: ['Cliente', 'Admin', 'Funcionario',  'Financeiro', 'Cadastradores', 'Advogado', 'AdminClientes'],
        model: {
          name: "",
          username: "",
          senha: ""
        },
        headers: [
          {
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'name'
          },{
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'username'
          },{
            text: 'Acesso',
            align: 'left',
            sortable: true,
            value: 'acesso'
          },
          { text: 'Ações', value: 'action', sortable: false }
        ]
      }
    },
    async created () {
      this.usuarios = await usuario.getUsuarios();
      //this.dialog = true;
      this.clientes = await cliente.getClientes();
      this.empresas = await empresaCtrl.getAll();
      
      if (store.getters.user) {
        this.user = await usuario.getUsuario(store.getters.user._id);
      }
      //this.dialog = false;
      // this.devedores = await devedores.getDevedores();
    },
    methods: {
      novo: function () {
        this.dialog = true;
        // this.$refs.meta1.$el.getElementsByTagName('input')[0].value = 0;
        // this.$refs.meta2.$el.getElementsByTagName('input')[0].value = 0;
        // this.$refs.meta3.$el.getElementsByTagName('input')[0].value = 0;
        this.model = {
          name: "",
          username: "",
          password: ""
        }
      },
      deleteItem: function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          usuario.deleteUser(even._id).then((res) => {
            this.dialogConfirmation = false;
            this.excluindo = null;
            usuario.getUsuarios().then((res) => {
              this.usuarios = res;
            });
          });
        }
      },
      editItem: function (even) {
        //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
        this.dialog = true;
        this.editando = true;
        this.model = {...even};
        this.$forceUpdate();
        this.model.internal = undefined;
        this.model.flags = undefined;
        // this.$refs.meta1.$el.getElementsByTagName('input')[0].value = even.meta1?even.meta1.toFixed(2):0;
        // this.$refs.meta2.$el.getElementsByTagName('input')[0].value = even.meta2?even.meta2.toFixed(2):0;
        // this.$refs.meta3.$el.getElementsByTagName('input')[0].value = even.meta3?even.meta3.toFixed(2):0;
        
      },
      editSenha: function (even) {
        //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
        this.dialogSenha = true;
        this.model = {...even};
        this.$forceUpdate();
        this.model.internal = undefined;
        this.model.flags = undefined;
        
      },
      save: function () {
        this.$validator.validateAll().then((errors) =>  {
          if (errors) {
            if (this.editando) {
              usuario.alterarUsuario(this.model._id, this.model).then((res) => {
                if (res.data && res.data.error) {
                  this.message = res.data.error.data;
                  this.dialogError = true;
                } else {
                  this.clear();
                  usuario.getUsuarios().then((res) => {
                    this.usuarios = res;
                  });
                }
                
                this.editando = false;
              });
            } else {
              usuario.saveUsuario(this.model).then((res) => {
                if (res.data && res.data.error) {
                  this.message = res.data.error.data;
                  this.dialogError = true;
                } else {
                  this.clear();
                  usuario.getUsuarios().then((res) => {
                    this.usuarios = res;
                  });
                }
                
                this.editando = false;
              });
            }
          }
        });
        
      },
      saveSenha: async function () {
        let errors = await this.$validator.validateAll();
        if (errors) {
          let res = await usuario.saveUsuarioSenha(this.model);
          if (res.data && res.data.error) {
            this.message = res.data.error.data;
            this.dialogError = true;
          } else {
            this.clearSenha();
            this.usuarios = await usuario.getUsuarios();
          }
        }
        
      },
      clearSenha: function () {
        this.model = {
          name: "",
          username: "",
          password: ""
        }
        this.editando = false;
        this.$validator.reset()
        this.dialogSenha = false;
      },
      clear: function () {
        this.model = {
          name: "",
          username: "",
          password: ""
        }
        this.editando = false;
        this.$validator.reset()
        this.dialog = false;
      }

    },
    directives: {money: VMoney}
  }
</script>


// WEBPACK FOOTER //
// src/pages/user/Usuarios.vue